import Header from "layout/Header2/Header"
import { Slide } from "react-reveal"

const Stake = () => {
    return (
        <main id="stake">
            <Header />
            <div className="container ">
                <div className="sec-heading-wrapper">
                    <Slide bottom>
                        <h1 className="sec-heading">Staking</h1>
                    </Slide>
                </div>
                <div className="description text-center">
                    <Slide bottom>
                        <p>
                            Stake your Business Ape here to earn 10 Jungle Bonds ($JBND) per day. The $JBND will be exchangeable for our future projects such as our second NFT collection – granting you to earn new NFTs for free.
                        </p>
                        <p>
                            Our second collections NFT will be exchangeable for 750 Jungle Bonds meaning you can earn yourself a free NFT every 2 ½ Months. Stay tuned for more news.
                        </p>
                    </Slide>
                    <Slide bottom>
                        <div className="stake-box">
                            <h3 className="claimPoints">( 0 )</h3>
                            <button className="mint-now-">Claim</button>
                        </div>
                    </Slide>
                    <Slide bottom>
                        <button className="mint-now-">Stake &nbsp; +</button>
                    </Slide>
                </div>
            </div>
        </main>
    )
}

export default Stake
